import { render, staticRenderFns } from "./MonetaryDashboard.vue?vue&type=template&id=64bf656d&scoped=true&"
import script from "./MonetaryDashboard.vue?vue&type=script&lang=js&"
export * from "./MonetaryDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MonetaryDashboard.vue?vue&type=style&index=0&id=64bf656d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bf656d",
  null
  
)

export default component.exports